import axios from 'axios';
// import store from '../store';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}
const baseurl = 'agunankredit';
export default {
    save(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post(baseurl, obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    list(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'kota', 'nilai1', 'nilai2', 'tgl1', 
                'tgl2', 'no_jaminan', 'sertifikatno', 'pemilikjaminan', 'tipejaminan', 'statusasuransi','jaminankeys',
                'sourceproject'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    detail(key) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`${baseurl}/detail/${key}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    getPinjamanAgunan(jaminankey) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`${baseurl}/getPinjamanAgunan/${jaminankey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    getjaminan(pinjamankey) {
        return new Promise(async (resolve, reject) => {
            try {
                console.log("#pinjamankey: ", pinjamankey);
                const { data } = await axios.get(`${baseurl}/getjaminan/${pinjamankey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    exportxls(obj = {}) {
        return new Promise((resolve, reject) => {
            try {
                const keys = ['sortBy', 'sortDir', 'lokasijaminan', 'tgl1', 'tgl2', 'nilai1', 'nilai2', 'no_kontrak', 'pemilikjaminan', 'tipejaminan', 'statusasuransi'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}/exportxls/${str}`;
                axios({
                    url: url,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'agunan.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    importdtxls(filexls, obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const fd = new FormData();
                fd.append('fileXlsx', filexls, filexls.name);
                for (const key in obj) {
                    fd.append(key, obj[key]);
                }
                const { data } = await axios.post(`${baseurl}/importdtxls`, fd);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    savebulk(arr) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post(`${baseurl}/savebulk`, arr);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    printpdf(obj){
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['pinjamankey','jaminankey'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}/printpdf${str}`;
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    getAsset(pinjamankey) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`${baseurl}/getAsset/${pinjamankey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
}